<div class="quickbet-content" [ngClass]="{ suspended: selection.disabled || isLogAndQuickBetPending }" data-crlat="quickbet.content">
    <div class="quickbet-sectionwrap">
        @if (isFullOverlay) {
            <section class="qb-full-overlay-selection-remove-btn">
                <div class="qb-remove-btn" data-crlat="selectionCloseButton" (click)="removeSelection()">
                    <svg>
                        <use xlink:href="#close-icon"></use>
                    </svg>
                </div>
            </section>
        }
        @if (selection.outcomeId) {
            <section class="qb-content-info" [ngClass]="{ 'odd-boost-active': canBoostSelection }">
                @if (!isLuckyDip) {
                    <p class="outcome-name" [textContent]="selection?.outcomeName | callBack: filterPlayerName : this" data-crlat="selectionName"></p>
                    <p class="market-name" [textContent]="filterAddScore(selection)" data-uat="marketName"></p>
                } @else {
                    <p class="outcome-name" [textContent]="selection?.marketName?.split(',')[0]"></p>
                    <p class="market-name" [textContent]="luckyDipMarketName" data-uat="marketName"></p>
                }
                <p class="event-name" [textContent]="selection.eventName" data-uat="eventName"></p>
                @if (extraPlaceName && (extraPlaceCheck() || isWinorEachWay)) {
                    <div class="extraplacesignpostOffer_coral" [textContent]="extraPlaceName"></div>
                }
            </section>
        }
        @if (!selection.outcomeId) {
            <section class="yc-content-info" data-crlat="section.selections">
                <ng-content select="your-call-body-details"></ng-content>
            </section>
        }
        <section id="quickBetEW" class="qb-stake-section" data-crlat="section.stake">
            <div class="qb-odds-stake-wrapper">
                <div class="odds">
                    @if (!isLuckyDip) {
                        @if (selection.hasLP) {
                            <span
                                class="odds-value"
                                [ngClass]="{ crossed: canBoostSelection && selection.isBoostActive }"
                                [textContent]="selection.newOddsValue || selection.oldOddsValue"
                                data-crlat="odds"></span>
                        }
                        @if (selection.hasSP) {
                            <span class="odds-value" [i18n]="'quickbet.isSP'" data-crlat="odds"></span>
                        }
                        @if (selection.hasSPLP) {
                            <label class="odds-select-label" data-crlat="odds">
                                <lazy-component
                                    moduleUri="@freebetsModule/freebets.module#FreebetsModule"
                                    [inputs]="{
                                        options: selection.oddsSelector,
                                        selectedValue: selection.isLP ? 'LP' : 'SP',
                                        disabled: selection.disabled,
                                        mode: canBoostSelection && selection.isBoostActive ? 'secondary' : 'default',
                                    }"
                                    [outputs]="['valueChange']"
                                    (event)="priceTypeChange($event)"
                                    entryComponent="LpSpDropdownComponent">
                                </lazy-component>
                            </label>
                        }

                        <!-- Boosted price -->
                        @if (canBoostSelection && selection.isBoostActive) {
                            <lazy-component
                                moduleUri="@oddsBoostModule/odds-boost.module#OddsBoostModule"
                                entryComponent="OddsBoostPriceComponent"
                                [inputs]="{ oldPrice: boostOldPrice, newPrice: boostNewPrice }"
                                class="quickbet-boosted-price">
                            </lazy-component>
                        }
                    } @else {
                        @if (selection?.marketName) {
                            <span
                                class="odds-value"
                                [textContent]="selection?.marketName?.split(',')[2] || selection.oldOddsValue"
                                data-crlat="odds"></span>
                        }
                    }
                </div>
                <div class="stake" data-crlat="stake.amountInputForm">
                    <div>
                        <label
                            [ngClass]="selectionAmountClasses"
                            class="input-stake-label"
                            [attr.data-currency]="selection.currency"
                            [textContent]="selection.stake ? selection.currency : ''">
                        </label>
                        <input
                            #qbInputStake
                            id="stake-input"
                            class="stake-input"
                            placeholder="Stake"
                            [digit-keyboard-input]
                            [selectedFreeBet]="selectedFreeBet"
                            [freebetsList]="freebetsList"
                            (freeBetSelected)="onFreebetChange($event)"
                            [freebetsConfig]="freebetsConfig"
                            [isBoostEnabled]="isBoostEnabled"
                            [fanzoneList]="fanzoneList"
                            [betPackList]="betPackList"
                            [isSelectionBoosted]="this.selection.isBoostActive"
                            [canBoostSelection]="canBoostSelection"
                            [patternRestrict]="stakePattern"
                            [patternToFixed]="true"
                            [componentId]="isFullOverlay ? 'quickbet-updated-panel' : 'quickbet-panel'"
                            [showDecimalPoint]="true"
                            [value]="selection.stake"
                            [(ngModel)]="selection.stake"
                            (ngModelChange)="onStakeChange()"
                            [disabled]="
                                selection.disabled ||
                                isLogAndQuickBetPending ||
                                showPendingSpinner() ||
                                serviceClosureService.userServiceClosureOrPlayBreak
                            "
                            [eventAction]="'quickbet'"
                            data-money-validate="true"
                            data-crlat="value" />
                    </div>
                </div>
            </div>
            @if (selection.isEachWayAvailable) {
                <div class="each-way" data-crlat="eachWayForm">
                    <div class="each-way-highlight eachWay-tooltip">
                        @if (disableEachWayTooltip) {
                            <div [tooltip]="'eachWay'" [toolTipArgs]="toolTipArgs" [showTooltip]="disableEachWayTooltip"></div>
                        }
                        <span class="each-way-label" [i18n]="'quickbet.eachWayLabel'" data-crlat="label.eachWay"></span>
                        <input
                            id="each-way-checkbox"
                            class="each-way-checkbox"
                            type="checkbox"
                            placeholder="0.00"
                            [disabled]="selection.disabled || showPendingSpinner() || serviceClosureService.userServiceClosureOrPlayBreak"
                            (change)="onStakeChange()"
                            [(ngModel)]="selection.isEachWay"
                            data-uat="eachWay" />
                        <label for="each-way-checkbox"></label>
                    </div>
                </div>
            }
        </section>
    </div>
    @if (selection.categoryId == '16' && selection?.markets?.length) {
        <div class="twoUpMarketContent">
            <promotion-icon
                [type]="'market'"
                [mode]="'sm'"
                [display]="selection.marketName"
                [marketName]="selection.marketName"
                [sport]="'sport'"
                data-crlat="promotionIcons"
                [disablePopUp]="true">
            </promotion-icon>
        </div>
    }
    <div class="promos-boost">
        <!-- Promo labels -->
        @if (selection?.markets?.length) {
            <promo-labels
                [cashoutValue]="selection.markets[0].isCashoutAvailable"
                [event]="selection"
                [marketId]="selection.marketId"
                [mode]="'quickbetslip'"
                [exclude]="promoLabelsFlagsExcluded">
            </promo-labels>
        }

        <!-- Boost button -->
        @if (canBoostSelection) {
            <div class="quickbet-boost-button">
                <lazy-component
                    moduleUri="@oddsBoostModule/odds-boost.module#OddsBoostModule"
                    entryComponent="OddsBoostButtonComponent"
                    (click)="onBoostClick()"
                    [inputs]="{
                        enabled: selection.isBoostActive,
                        reboost: selection.reboost,
                        disabled: placeBetPending.state,
                        isQuickBet: isQuickBet,
                    }">
                </lazy-component>
            </div>
        }
    </div>
    @if (selection.isEachWay && selectedFreeBet && !selection.hasSP && selection.isLP && !selection.disabled) {
        <lazy-component
            moduleUri="@lazy-modules-module/signposting/signposting.module#SignpostingModule"
            entryComponent="FreebetSignpostingComponent"
            [inputs]="{ betInfo: selection, signpostingTitle: 'eachway', eventLocation: 'quickbet' }">
        </lazy-component>
    }
</div>

<digit-keyboard
    [componentId]="isFullOverlay ? 'quickbet-updated-panel' : 'quickbet-panel'"
    [currency]="selection.currency"
    [hideKeyboardFlag]="false"
    [disabled]="selection.disabled || isLogAndQuickBetPending || showPendingSpinner() || serviceClosureService.userServiceClosureOrPlayBreak"
    (keyboardShown)="onKeyboardToggle(false)"
    (keyboardHidden)="onKeyboardToggle(true)"
    #qbDigitKeyboard>
</digit-keyboard>

<quick-stake
    [quickStakeVisible]="quickStakeVisible"
    [freebetsList]="freebetsList"
    [selectedFreeBet]="selectedFreeBet"
    [betPackList]="betPackList"
    [fanzoneList]="fanzoneList"
    [disabled]="selection.disabled || placeBetPending.state || isLogAndQuickBetPending || serviceClosureService.userServiceClosureOrPlayBreak"
    [freebetsConfig]="freebetsConfig"
    [isBoostEnabled]="isBoostEnabled"
    [isSelectionBoosted]="this.selection.isBoostActive"
    [canBoostSelection]="canBoostSelection"
    (quickStakeSelect)="onQuickStakeSelect($event)"
    (fbChange)="onFreebetChange($event)"
    data-crlat="quickStakePanel"
    [betslipType]="betslipType"
    [isFullOverlay]="isFullOverlay">
</quick-stake>
@if (canBoostSelection && selection.price.isPriceChanged && selection.isBoostActive) {
    <div class="reboost-info">
        <svg class="alert-icon">
            <use xlink:href="#icn_info"></use>
        </svg>
        <span [i18n]="'quickbet.reboostPriceChanged'"></span>
    </div>
}
@if (maxPayedOut && maxPayFlag) {
    <lazy-component
        moduleUri="@lazy-modules-module/maxpayOutErrorContainer/maxpayout-error-container.module#MaxpayoutErrorContainerModule"
        [inputs]="{ betType: 'quick bet', errorMsg: maxPayMsg }"
        entryComponent="MaxpayoutErrorContainerComponent"
        data-crlat="maxPayout">
    </lazy-component>
}
<bet-summary
    [selection]="selection"
    [jump]="'jump'"
    (showMaxPayOutMessage)="addItem($event)"
    [maxPayOutValue]="selection.maxPayout"
    data-crlat="betSummary"></bet-summary>

<div class="quickbet-controls">
    @if (!isLuckyDip && addToBetslipFn) {
        <button
            class="qb-left-cta-btn"
            (click)="addToBetslipFnHandler()"
            [textContent]="leftBtnText"
            [disabled]="selection.disabled || isLogAndQuickBetPending || showPendingSpinner() || serviceClosureService.userServiceClosureOrPlayBreak"
            data-crlat="addToBetslipButton"></button>
    }
    @if (isLuckyDip && !addToBetslipFn) {
        <button
            class="qb-left-cta-btn"
            (click)="closeFnHandler()"
            [disabled]="selection.disabled || isLogAndQuickBetPending"
            [i18n]="getbackBtnCTAText()"
            data-crlat="quickbet.back"></button>
    }
    @if (!isMakeQuickDeposit()) {
        <button
            class="qb-right-cta-btn"
            [disabled]="disablePlaceBet || isLogAndQuickBetPending || serviceClosureService.userServiceClosureOrPlayBreak"
            (click)="placeBetFnHandler()"
            data-crlat="placeBetButton">
            @if (showPendingSpinner()) {
                <spinner></spinner>
            }
            @if (!showPendingSpinner() && isUserLoggedIn) {
                <span [i18n]="getPlaceBetText"></span>
            }
            @if (showPendingSpinner() && isUserLoggedIn && !selection.isStarted) {
                <span [i18n]="getPlaceBetText"></span>
            }
            @if (showPendingSpinner() && isUserLoggedIn && selection.isStarted && countDownTimer) {
                <span>{{ countDownTimer.value }}</span>
            }
            @if (!showPendingSpinner() && !isUserLoggedIn) {
                <span [i18n]="'quickbet.buttons.loginPlaceBet'"></span>
            }
        </button>
    } @else {
        <button
            class="qb-right-cta-btn qb-quick-deposit-button"
            [disabled]="isSelectionDisabled()"
            (click)="openQuickDepositFnHandler()"
            data-crlat="quickDepositButton">
            @if (showSpinnerOnQuickDeposit()) {
                <spinner data-crlat="spinner.loader"></spinner>
            }
            <span [i18n]="'quickbet.buttons.makeQuickDeposit'"></span>
        </button>
    }
</div>
